module.exports = __webpack_public_path__ + "img/GAME_AIRPLANE.708a3c0c.png";